import React from "react";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import BoltIcon from "./BoltIcon";
import PendingActionsIcon from "./PendingActionsIcon";
import { TestRequestFlag } from "./RequestFlag";
import CopyIcon from "./CopyIcon";

const REQUEST_FLAG_ICONS_MAPPING: {
  [F in TestRequestFlag]: React.ReactElement;
} = {
  DEADLINE_MAY_NOT_BE_MET: <BoltIcon />,
  DUPLICATED: <CopyIcon />,
  HISTORICAL: <AccountBalanceIcon />,
  OVERDUE: <ReportProblemOutlinedIcon />,
  SPECIFICATION_NEEDED: <></>,
  WAITING_FOR_MATERIAL: <PendingActionsIcon />,
};

interface RequestFlagIconProps {
  flag: TestRequestFlag;
}

const RequestFlagIcon: React.FC<RequestFlagIconProps> = (props) => {
  const { flag } = props;

  return REQUEST_FLAG_ICONS_MAPPING[flag];
};

export default RequestFlagIcon;
